// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Header_wrapper__9CK2E"};